import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import {
    Dic
} from "@src/common/utils";
const tableOption = function (type) {
    let status = Dic.find("SENU080001");
    let obj = {
        view: "审批详情",
        page: true,
        selection: true,
        index: true,
        indexLabel: "序号",
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: true,
        editBtn: false,
        delBtn: false,
        align: "left",
        size: "small",
        maxHeight: "100%",
        labelWidth: "100px",
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 400,
        dialogWidth: "700px",
        emptyText: "暂无数据",
    }
    if (type == '0') {
        obj.column = [

            // {
            //     label: "来访编号",
            //     prop: "visitCode",
            // },
            // {
            //     label: "接待人",
            //     prop: "visitorReceiverName",

            // },
            // {
            //     label: "来访人数",
            //     prop: "visitorsNumber",
            //     width: 100,
            // },
            {
                label: "访客姓名",
                prop: "name",
                search: true
            },
            {
                label: "访问部门",
                prop: "receiverDepartmentNames",
            },
            {
                label: "电话号码",
                prop: "phone",
                // width: 140
            },
            {
                label: "接口人",
                prop: "receiverNames",

            },
            {
                label: "来访目的",
                prop: "visitorReason",
            },
            {
                label: "访问时间",
                prop: "enterTime",

            },
            {
                label: "登记时间",
                prop: "createTime",
                search: true,
                searchSlot: true
            },
            {
                label: "登记终端",
                prop: "createTime",
            },

        ]
    } else {
        obj.column = [

            // {
            //     label: "来访编号",
            //     prop: "visitCode",
            // },
            // {
            //     label: "接待人",
            //     prop: "visitorReceiverName",

            // },
            // {
            //     label: "来访人数",
            //     prop: "visitorsNumber",
            //     width: 100,
            // },
            {
                label: "访客姓名",
                prop: "name",
                search: true
            },
            {
                label: "访问部门",
                prop: "receiverDepartmentNames",
            },
            {
                label: "电话号码",
                prop: "phone",
                // width: 140
            },
            {
                label: "接口人",
                prop: "receiverNames",

            },
            {
                label: "来访目的",
                prop: "visitorReason",
            },
            {
                label: "访问时间",
                prop: "enterTime",

            },
            {
                label: "审批时间",
                prop: "createTime",
                // search: true,
                // searchSlot: true
            },
            {
                label: "登记时间",
                prop: "createTime",
                search: true,
                searchSlot: true,
                hide: true
            },
            // {
            //     label: "登记终端",
            //     prop: "createTime",

            // },
            {
                label: "审批结果",
                prop: "status",
                dicData: Dic.find('SENU080001'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU080001', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU080001', value) : ''
                },

            },

        ]
    }
    return obj
};
export default tableOption;